import React from 'react'
import PropTypes from 'prop-types'
import ProductClasses from 'components/dashboard/ProductClasses'

/**
 * K8ProgramStatusRouter component
 *
 * This component serves as a router for K8 program status views.
 * Currently, it renders ProductClasses as a default case, but it's set up
 * to potentially display alternative views based on state checking logic
 * that will be added in the future.
 */
const K8ProgramStatusRouter = React.forwardRef((props, ref) => {
  // Ensure required props have default values for tests
  const enhancedProps = {
    ...props,
    currentProgramName: props.currentProgramName || 'default-program',
    contentfulCourses: props.contentfulCourses || [],
    classes: props.classes || [],
    displayTitle: props.displayTitle || 'Default Title',
    internalTitle: props.internalTitle || 'default-internal-title',
    isK5Product: props.isK5Product || false,
    isMsProduct: props.isMsProduct || false,
    onClassBlur: props.onClassBlur || (() => {}),
    onClassFocus: props.onClassFocus || (() => {}),
    onComponentClick: props.onComponentClick || (() => {}),
    setFocus: props.setFocus || (() => {}),
    staticLinksAvailable: props.staticLinksAvailable || [],
  }

  return <ProductClasses {...enhancedProps} ref={ref} />
})

// Using modified prop types from ProductClasses with defaults for testing
K8ProgramStatusRouter.propTypes = {
  classMenuButtonRefs: PropTypes.object,
  classes: PropTypes.array,
  contentfulCourses: PropTypes.array,
  currentProgramName: PropTypes.string,
  displayTitle: PropTypes.string,
  entryId: PropTypes.string,
  firstTimeMS: PropTypes.bool,
  headerDataTestId: PropTypes.string,
  index: PropTypes.number,
  internalTitle: PropTypes.string,
  isK5Product: PropTypes.bool,
  isMsProduct: PropTypes.bool,
  onClassBlur: PropTypes.func,
  onClassFocus: PropTypes.func,
  onComponentClick: PropTypes.func,
  program: PropTypes.object,
  programSubheader: PropTypes.string,
  setFocus: PropTypes.func,
  staticLinksAvailable: PropTypes.array,
}

// Add a display name for debugging purposes
K8ProgramStatusRouter.displayName = 'K8ProgramStatusRouter'

export default K8ProgramStatusRouter
